import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c4a0940")

_pushScopeId("data-v-5c4a0940")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("管理中心")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("权限管理")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = {
  class: "project-management",
  style: {"position":"relative"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-delete-solid",
  style: {"font-size":"20px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-delete-solid",
  style: {"font-size":"20px"}
}, null, -1)
const _hoisted_7 = { class: "dialogTitle" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "添加项目成员", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("管理员权限")
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("返 回")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("提 交")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_main, null, {
        default: _withId(() => [
          _createVNode(_component_el_breadcrumb, {
            "separator-class": "el-icon-arrow-right",
            class: "PosTitle"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _ctx.addMemberAdmin,
                type: "primary",
                size: "small",
                class: "btnStyle",
                disabled: _ctx.get_is_super2
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_card, { class: "tableMinH" }, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_el_table, {
                  size: "mini",
                  data: 
              _ctx.get_project_users.filter((data) =>
                data.user.toLowerCase().includes(_ctx.admin_search.toLowerCase())
              )
            ,
                  "header-cell-class-name": "tabelHeader"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table_column, { width: "25" }),
                    _createVNode(_component_el_table_column, {
                      prop: "user",
                      label: '项目用户'
                    }),
                    _createVNode(_component_el_table_column, { label: "管理员权限" }, {
                      default: _withId((scope) => [
                        (_ctx.get_is_super)
                          ? (_openBlock(), _createBlock("input", {
                              key: 0,
                              class: "mui-switch mui-switch-anim",
                              type: "checkbox",
                              onClick: ($event: any) => (_ctx.admin_change(scope.row)),
                              id: 'admin_change' + scope.row.id,
                              checked: scope.row.is_project_admin,
                              disabled: scope.row.user === _ctx.get_username
                            }, null, 8, ["onClick", "id", "checked", "disabled"]))
                          : (_openBlock(), _createBlock("input", {
                              key: 1,
                              class: "mui-switch mui-switch-anim",
                              type: "checkbox",
                              onClick: ($event: any) => (_ctx.admin_change(scope.row)),
                              id: 'admin_change' + scope.row.id,
                              checked: scope.row.is_project_admin,
                              disabled: _ctx.get_is_super2
                            }, null, 8, ["onClick", "id", "checked", "disabled"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { align: "center" }, {
                      header: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.admin_search,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.admin_search = $event)),
                          size: "mini",
                          placeholder: "search"
                        }, null, 8, ["modelValue"])
                      ]),
                      default: _withId((scope) => [
                        _createVNode(_component_el_popconfirm, {
                          onConfirm: ($event: any) => (_ctx.handleAdminRemoveMember(scope.row)),
                          title: "确认移除该用户?"
                        }, {
                          reference: _withId(() => [
                            (_ctx.get_is_super)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "text",
                                  size: "mini",
                                  disabled: scope.row.user === _ctx.get_username
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 2
                                }, 1032, ["disabled"]))
                              : (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "text",
                                  size: "mini",
                                  disabled: _ctx.get_is_super2
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]), [
                  [_directive_loading, _ctx.admin_loading]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_dialog, {
              width: "30%",
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetAddMemberAdminForm('ruleaddMemberAdminForm'))),
              modelValue: _ctx.dialogAddMemberAdminFormVisible,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogAddMemberAdminFormVisible = $event))
            }, {
              title: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_divider)
                ])
              ]),
              footer: _withId(() => [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetAddMemberAdminForm('ruleaddMemberAdminForm')))
                  }, {
                    default: _withId(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (
                  _ctx.submitAddMemberAdminForm(
                    'ruleaddMemberAdminForm',
                    _ctx.addMemberForm
                  )
                ))
                  }, {
                    default: _withId(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withId(() => [
                _createVNode(_component_el_form, {
                  size: "mini",
                  model: _ctx.addMemberForm,
                  rules: _ctx.addMemberRules,
                  ref: "ruleaddMemberAdminForm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tooltip, {
                      placement: "bottom",
                      "popper-class": "testtooltip"
                    }, {
                      content: _withId(() => [
                        _hoisted_9,
                        _hoisted_10,
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: "英文id",
                          prop: "user"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.addMemberForm.user,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMemberForm.user = $event)),
                              modelModifiers: { trim: true },
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, {
                      style: {"margin-top":"20px"},
                      modelValue: _ctx.addMemberForm.is_project_admin,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMemberForm.is_project_admin = $event))
                    }, {
                      default: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})